var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection-control__wrapper"},[_c('FiltersForMyCollections',_vm._g({},_vm.$listeners)),_c('Controls',_vm._g({on:{"toggle:view":_vm.getToggleView}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }